import { useAuth, useGlobalActivityTracker } from '@data-delivery/okta-auth-react';
import { clearCurrentUserRoles } from '@data-delivery/permission-ui-data-access-state';
import { useCallback } from 'react';

export const ActivityTracker: React.FC = () => {
  const auth = useAuth();

  const handleLogout = useCallback(() => {
    clearCurrentUserRoles();

    auth.logout();
  }, [auth]);

  useGlobalActivityTracker({
    onSessionExpired: handleLogout,
    enableDebugLogs: false,
  });

  return null;
};
